import { type PropsWithChildren, useEffect } from 'react'
import { I18nProvider as ReactAriaI18nProvider } from 'react-aria'
import { I18nextProvider } from 'react-i18next'

import i18n from '@/i18n'
import useTypedTranslation from '@hooks/useTypedTranslation'

function I18nProvider({ children }: PropsWithChildren) {
  return <I18nextProvider i18n={i18n}>
    <AriaProviderWrapper>
      {children}
    </AriaProviderWrapper>
  </I18nextProvider>
}

// We need this wrapper to sync the language of react-i18n and react-aria
// react-aria uses the locale from the I18nProvider to format dates, numbers, etc.
function AriaProviderWrapper({ children }: PropsWithChildren) {
  const { i18n } = useTypedTranslation()

  useEffect(() => {
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  return (
    <ReactAriaI18nProvider locale={i18n.language}>
      {children}
    </ReactAriaI18nProvider>
  )
}

export default I18nProvider